const NF_TEXT = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  useGrouping: false,
  notation: 'standard',
});

const NF_FULL = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  useGrouping: true,
  notation: 'standard',
});

const NF_COMPACT = new Intl.NumberFormat('en-US', {
  notation: 'compact',
  maximumFractionDigits: 2,
});

const NF_BALANCE = new Intl.NumberFormat(undefined, {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatMultiplierText(mult: number): string {
  return `${NF_TEXT.format(mult)}x`;
}

export function formatMultiplierFull(mult: number): string {
  return `${NF_FULL.format(mult)}x`;
}

export function formatMultiplier(mult: number): { text: string; title: string } {
  return {
    text: formatMultiplierText(mult),
    title: formatMultiplierFull(mult),
  };
}

export function formatCompact(value: number): string {
  return NF_COMPACT.format(value);
}

export function formatBalance(value: number): string {
  return NF_BALANCE.format(value);
}

export function formatCurrency(value: number): string {
  return value.toLocaleString(undefined, { style: 'currency', currency: 'USD', minimumFractionDigits: 2 });
}

export function formatCompactMultiplier(value: number): string {
  return `${NF_COMPACT.format(value)}x`;
}
